import axios from 'axios'
import moment from 'moment'
import JSZip from 'jszip'
import pako from 'pako'

export default {
    initialize: function () {
        window.ptUserId = parseInt(getParamValue('id'))
        window.chatUserId = getParamValue('user_id')
        const ptId = parseInt(getParamValue('pt_id'))
        window.chatUserPtId = !isNaN(ptId) ? ptId : null
        window.openedByApp = getParamValue('app') === 'true' ? true : false
        window.isPT = getParamValue('is_pt') === 'true' ? true : false
        window.audioEnabled = getParamValue('audio') === 'true' ? true : false
        window.audioLimitTime = !window.isPT ? 60000 : null
        window.theme = getParamValue('theme') === 'dark' ? 'dark' : 'light'
        window.triggerChatUserId = getParamValue('chat_user_id')
        window.registerUserId = getParamValue('register_user_id')
        window.chatUserToken = getParamValue('chat_token')
        window.apiDev = getParamValue('dev') === 'true' ? true : false
        window.chatDisabled = getParamValue('disabled') === 'true' ? true : false
        window.dashboardClientUrl = getParamValue('dashboard_client_url') === 'true' ? true : false
        window.dashboardNewPage = getParamValue('new_page') === 'true' ? true : false
        window.deleteRoomPermission = getParamValue('delete_room') === 'true' ? true : false
        const logId = parseInt(getParamValue('log_id'))
        window.logId = !isNaN(logId) ? logId : null
        window.logEmail = getParamValue('log_email')
        window.logName = getParamValue('log_name')
        window.language = getLanguage()
        window.datepickerLanguage = getDatepickerLanguage()
        window.apiKey = getApiKey()
        window.ptSocketsAvailable = window.chatUserPtId && PTS_IDS && PTS_IDS['TG'] === window.chatUserPtId ? true : false
        window.mqttKeys = {
            'tiago_guimaraes_es': 'es'
        }

        document.body.style.backgroundColor = window.theme === 'dark' ? '#000' : '#fff'

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng === 'en') {
                return lng
            }
            if (lng === 'es') {
                return lng
            }
            if (lng === 'fr') {
                return lng
            }
            return 'pt'
        }

        function getDatepickerLanguage() {
            if (window.language === 'en') {
                return 'en-EN'
            }
            if (window.language === 'es') {
                return 'es-ES'
            }
            if (window.language === 'fr') {
                return 'fr-FR'
            }
            return 'pt-PT'
        }

        function getApiKey() {
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }
    },
    getPtConfig: function () {
        return {
            '-3': {
                filesFolder: 'tgchat',
                roomsPagination: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomsPaginationEnabled'
                },
                pagesEmployees: {
                    onlyPt: false,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'pagesEmployeesEnabled'
                },
                roomTyping: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomTypingEnabled'
                },
                draft: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'draftEnabled'
                },
                filters: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'filtersEnabled'
                },
                roomOptions: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomOptionsEnabled'
                },
                dashboardClient: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'openDashboardClientEnabled'
                },
                roomName: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'changeRoomNameEnabled'
                },
                roomNotes: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'showNotes'
                },
                pinRoom: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomFixedEnabled'
                },
                archiveRoom: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomArchivedEnabled'
                },
                sendMessageToAll: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'sendMessageToAllEnabled'
                },
                nativeKeyboardEnabled: {
                    onlyPt: false,
                    onlyClient: true,
                    dev: false,
                    onlyIos: true,
                    field: 'nativeKeyboardEnabled'
                },
                audio: {
                    all: true,
                    value: 'true',
                    field: 'showAudio'
                },
                autoLoadMessagesFiles: {
                    all: true,
                    field: 'autoLoadMessagesFiles'
                },
                tags: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'tagsEnabled'
                },
                pendingFeedbacks: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'pendingFeedbacksEnabled'
                },
                updateDateFeedback: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'updateFeedbackDateEnabled'
                },
                roomFlags: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomFlagsEnabled'
                },
                updateTags: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomUpdateTagsEnabled'
                },
                newCalendarEvent: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'newCalendarEventEnabled'
                },
                showImages: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'showImagesEnabled'
                },
                sendVideo: {
                    all: true,
                    field: 'sendVideoEnabled',
                    addValue: {
                        field: 'acceptedFiles',
                        value: ', video/mp4, video/webm, video/quicktime'
                    }
                },
                openDashboardRegister: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'openDashboardRegisterEnabled'
                },
                IASummary: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: true,
                    onlyIos: false,
                    field: 'IASummaryEnabled'
                },
                roomSummaryNotes: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'roomSummaryNotesEnabled'
                },
                replyMessage: {
                    onlyPt: false,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'replyMessageEnabled'
                },
                fixMessage: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'fixMessageEnabled'
                },
                increaseFontSize: {
                    onlyPt: false,
                    onlyClient: true,
                    dev: false,
                    onlyIos: false,
                    field: 'increaseFontSizeEnabled'
                },
                saveFeedbackMessage: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'saveFeedbackMessageEnabled'
                },
                showSubscription: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'showSubscriptionEnabled'
                },
                showHasPlans: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'showHasPlansEnabled'
                },
                deleteRoom: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'deleteRoomEnabled'
                },
                roomAdminUnread: {
                    all: true,
                    field: 'useRoomAdminUnread'
                },
                filtersGroups: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'filtersGroupsEnabled'
                },
                hideRoomUnreadMessagesValue: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'hideRoomUnreadMessagesValueEnabled'
                },
            },
            '-14': {
                filesFolder: 'franciscoespin',
                filterEmployee: {
                    onlyPt: true,
                    onlyClient: false,
                    dev: false,
                    onlyIos: false,
                    field: 'filterEmployeeEnabled'
                },
            },
            '-11': {
                filesFolder: 'nacholopez'
            },
            '-21': {
                filesFolder: 'topathlete'
            }
        }
    },
    getAuthorization: function (api) {
        let user = null
        let password = null
        if (api === 'chat') {
            const utcDate = moment.utc()
            const year = parseInt(utcDate.format('YYYY'))
            const month = parseInt(utcDate.format('MM'))
            const day = parseInt(utcDate.format('DD'))
            const hour = parseInt(utcDate.format('HH'))
            const isEven = !(hour % 2)
            if (isEven) {
                user = year + month + day + hour
                password = (year * month) + (day * hour)
            } else {
                user = year - month - day - hour
                password = (year * day) - (month * hour)
            }
            user = window.btoa(user)
            password = window.btoa(password)
        } else if (api === 'chat_username') {
            user = JSON.parse(process.env.VUE_APP_EMAIL).chat
            password = JSON.parse(process.env.VUE_APP_PASSWORD).chat
        } else if (api === 'storage') {
            user = JSON.parse(process.env.VUE_APP_EMAIL).storage
            password = JSON.parse(process.env.VUE_APP_PASSWORD).storage
        } else {
            user = JSON.parse(process.env.VUE_APP_EMAIL).pt
            password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        }
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    refreshEnums: function (enums) {
        try {
            if (window.strings) {
                for (const key in enums) {
                    if (enums[key]) {
                        for (let i = 0; i < enums[key].length; i++) {
                            if (enums[key][i].label) {
                                enums[key][i].label = window.strings[enums[key][i].label] ? window.strings[enums[key][i].label] : enums[key][i].label
                            }
                        }
                    }
                }
            }
        } catch (error) { }
        window.enums = enums
    },
    validateChatToken: function (callback, usernameAuthorization) {
        const self = this
        const currentDate = moment.utc().format('YYYY-MM-DDTHH:mm:ss')
        if (!axios.defaults.chatAuthorizationToken || !axios.defaults.chatAuthorizationExpireDate || (axios.defaults.chatAuthorizationExpireDate && axios.defaults.chatAuthorizationExpireDate <= currentDate)) {
            axios.post(axios.defaults.chatApiUrl + 'login?lng=' + window.language,
                {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: usernameAuthorization ? this.getAuthorization('chat_username') : this.getAuthorization('chat'),
                }
            }).then((response) => {
                if (response.status === 200 && response.data && response.data.data && response.data.data.id) {
                    axios.defaults.chatAuthorizationExpireDate = moment.utc().add(1, 'hours').format('YYYY-MM-DDTHH:mm:ss')
                    axios.defaults.chatAuthorizationToken = 'Bearer ' + response.data.data.id
                    callback()
                } else {
                    axios.defaults.chatAuthorizationExpireDate = null
                    axios.defaults.chatAuthorizationToken = null
                    if (usernameAuthorization) {
                        callback()
                    } else {
                        self.validateChatToken(callback, true)
                    }
                }
            }).catch(() => {
                axios.defaults.chatAuthorizationExpireDate = null
                axios.defaults.chatAuthorizationToken = null
                callback()
            })
        } else {
            callback()
        }
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            if (response && response.config && response.config.responseType === 'arraybuffer') {
                this.uncompressData(response.request.response, function (responseData) {
                    processResponse(responseData)
                })
            } else {
                processResponse(response.request.response)
            }

            function processResponse(requestResponse) {
                const responseData = requestResponse ? JSON.parse(requestResponse) : {
                    success: false,
                    data: null,
                    message: self.getMessageError(response),
                }
                callback({
                    success: responseData ? responseData.success : false,
                    data: responseData ? responseData.data : null,
                    message: responseData ? responseData.message : null,
                })
            }
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    uncompressData: function (data, callback) {
        try {
            const uint8Array = new Uint8Array(data)
            callback(pako.inflate(uint8Array, { to: 'string' }))
        } catch (error) {
            const zip = new JSZip()
            zip.loadAsync(
                data,
                { base64: false }
            ).then((zip) => {
                zip.forEach((relativePath, file) => {
                    file.async('string').then((content) => {
                        callback(content)
                    })
                })
            }).catch((error) => {
                callback(JSON.stringify({
                    success: false,
                    message: window.strings['common_error']
                }))
            })
        }
    },
    getMessageError: function (response) {
        let messageError = window.strings && window.strings['server_connection_failed'] ? window.strings['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }
        return messageError
    },
    getAlertOptions: function (confirmation, warning) {
        const str = window.strings ? window.strings : {
            'yes': 'Sim',
            'ok': 'Ok',
            'no': 'Não',
            'cancel': 'Cancelar'
        }
        return {
            confirmButtonText: confirmation ? str['yes'] : str['ok'],
            cancelButtonText: confirmation ? str['no'] : str['cancel'],
            confirmButtonColor: warning ? '#fb8c00' : '#509dc8',
        }
    },
    convertUtcDate: function (date, convertToUtcFormat, format) {
        try {
            if (!date) {
                return date
            }

            if (convertToUtcFormat) {
                date = moment(date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss')
            }

            if (date.indexOf(':') > -1) {
                let utcDate = date.replace(' ', 'T')
                if (utcDate.split(':').length < 3) {
                    utcDate += ':00'
                }
                utcDate += 'Z'
                return moment(utcDate).utcOffset(moment().utcOffset()).format(format ? format : 'YYYY-MM-DD HH:mm')
            } else {
                return date
            }
        } catch (error) {
            return date
        }
    },
    getUserTags: function () {
        const enums = window.enums
        if (enums && enums.user_tags) {
            return enums.user_tags
        } else {
            return []
        }
    },
    getChatCategories: function () {
        const enums = window.enums
        if (enums && enums.chat_categories) {
            return enums.chat_categories
        } else {
            return []
        }
    },
}
